<form id="frmsupplierknowledge" name="frmsupplierknowledge" #ngFrmsupplierknowledge="ngForm">
    <pre *ngIf="sharedDatasSvc.debug" class="pt-5">
        domaineActiviteDisabled = {{domaineActiviteDisabled}}
        specificitesDisabled = {{specificitesDisabled}}
        accidentologieDisabled= {{accidentologieDisabled}}
    </pre>
    <div class="card">
        <div class="card-header"><a class="control-label" data-toggle="collapse" href="#segmentscard" role="button"
                paflabel="Savoir_faire"></a>
        </div>
        <div id="segmentscard" class="card-body collapse show">
            <div class="row">
                <div class="col-12">
                    <label class="control-label" paflabel="Msg_selectionner_domaines_activites"></label>
                </div>
                <div class="col-8">
                    <div class="card">
                        <div class="card-header">
                            <label class="control-label" paflabel="Competences_disponibles"></label>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-5">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="box-380">
                                                <div class="box-content">
                                                    <kendo-listview [data]="displayedSegments"
                                                        class="k-noborder"
                                                        containerClass="k-d-flex k-flex-col k-flex-nowrap">
                                                        <ng-template kendoListViewItemTemplate let-dataItem="dataItem"
                                                            let-isFirst="isFirst">
                                                            <div style="display:flex;">
                                                                <input type="checkbox" kendoCheckBox
                                                                    name="segment{{dataItem.node.Cod}}"
                                                                    [(ngModel)]="dataItem.checked"
                                                                    (change)="reloadTree()" [disabled]="segmentNodeIsDisable(dataItem)">
                                                                <span class="ml-1 pl-3"
                                                                    [ngClass]="nodeClass(dataItem.node.Id)"
                                                                    style="flex:1;">{{familyNodeLabel(dataItem.node.Id)}}</span>
                                                            </div>
                                                        </ng-template>
                                                    </kendo-listview>
                                                    <PRE *ngIf="sharedDatasSvc.debug">
                                                        segments: {{segments | json}}
                                                    </PRE>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="col-7">
                                    <div class="d-flex flex-column align-items-stretch">
                                    <kendo-textbox class="mb-2" style="width: 100%;"
                                    (valueChange)="familyFilterChange($event)" [clearButton]="true" [disabled]="domaineActiviteDisabled || !isEditing()">
                                        <ng-template kendoTextBoxPrefixTemplate>
                                            <kendo-svgicon [icon]="searchIcon"></kendo-svgicon>
                                        </ng-template>
                                    </kendo-textbox>
                                    <div class="box-350 flex-grow-1">
                                        <div class="box-content">                                            
                                                <kendo-treeview class="k-hide-arrows tree-node-full-width" #treeView 
                                                    kendoTreeViewExpandable
                                                    name="treeFamilies"
                                                    [nodes]="parsedFamilies"
                                                    [hasChildren]="parsedFamilieshasChildren"
                                                    [children]="parsedFamiliesFetchChildren"
                                                    [filter]="familyFilter"
                                                    textField="Cod"                                                
                                                    [expandBy]="'Id'"
                                                    [(expandedKeys)]="expandedFamilyIds" 
                                                    [isExpanded]="isFamilyExpanded"
                                                    [isChecked]="isFamilyChecked" 
                                                    [kendoTreeViewCheckable]="checkableSettings"
                                                    [(checkedKeys)]="checkedIds" 
                                                    [checkBy]="'Id'"
                                                    [isDisabled]="isTreeActivitDomainyDisabled">
                                                    <ng-template kendoTreeViewNodeTemplate let-dataItem>
                                                        <div class="node-custom-item" [ngClass]="nodeClass(dataItem.Id)">
                                                            <!-- <div (click)="toggleCollapse(dataItem)"
                                                                class="node-custom-icon custom-tree-icon"
                                                                [ngClass]="collapseiconClass(dataItem)"></div> -->
                                                            <div class="node-custom-additional"
                                                                [innerHTML]="getHighlightText(dataItem)"></div>
                                                        </div>
                                                    </ng-template>
                                                </kendo-treeview>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
                <div class="col-4">
                    <div class="card">
                        <div class="card-header">
                            <label class="control-label" paflabel="Competences_selectionnees"></label>
                        </div>
                        <div class="card-body">
                            <div class="box-400">
                                <div class="box-content">
                                    <label class="text-danger control-label" *ngIf="FamiliesTooManySel()">
                                        <paflabel lblCod="Selection_trop_importante_Maximum"></paflabel> :
                                        {{FamiliesLimit}}
                                    </label>
                                    <kendo-treeview class="k-hide-arrows tree-node-full-width" #treeViewSel                                         
                                        kendoTreeViewExpandable
                                        kendoTreeViewFlatDataBinding
                                        name="'treeSupplierFamilies'"
                                        idField="Family.Id"
                                        parentIdField="Family.ParentId"
                                        [nodes]="selectedSupplierFamilies"
                                        [expandBy]="'Family.Id'" 
                                        [(expandedKeys)]="checkedIds"
                                        [isExpanded]="isExpandedSelection"                                         
                                        [isDisabled]="isTreeActivitDomainyDisabled"
                                        >
                                        <ng-template kendoTreeViewNodeTemplate let-dataItem>
                                            <div class="node-custom-item" [ngClass]="nodeClass(dataItem.FamilyId)">
                                                <div *ngIf="!domaineActiviteDisabled && isEditing()" class="node-custom-icon custom-tree-icon custom-tree-icon-nocheck very-small-icon" [ngClass]="nodeClassIcon(dataItem.FamilyId)" (click)="deleteSelectedFamily(dataItem.FamilyId)">
                                                    <i class="fas fa-trash-alt"></i>
                                                </div>
                                                <div class="node-custom-additional">{{familyNodeLabel(dataItem.Family.Id)}}</div>
                                            </div>
                                        </ng-template>
                                    </kendo-treeview>

                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
            <div class="row mt-1">
                <div class="col-12">
                    <label class="control-label" paflabel="Informations_complementaires_competences"></label>
                    <textarea [(ngModel)]="supplier.FamilyOther" class="form-control" name="FamilyOther" rows="3"
                        style="width:100%;height: 60px;" [disabled]="domaineActiviteDisabled || !isEditing()"></textarea>
                </div>
            </div>
            <div class="row my-2">
                <div class="col-2 my-1">
                    <label class="control-label" paflabel="Quel_est_votre_coeur_de_metier"></label>
                </div>
                <div class="col-4">
                    <kendo-dropdownlist class="control-label bg-white" style="width:100%;" #mainFamilyCodTree
                        name="mainFamilyCodTree" [data]="mainFamilyData" [listHeight]="300" [textField]="'Id'"
                        [valueField]="'FamilyId'" [(value)]="mainSupplierFamily" [disabled]="selectedSupplierFamilies.length==0 || domaineActiviteDisabled || !isEditing()"
                        required>
                        <ng-template kendoDropDownListValueTemplate let-dataItem>
                             <div style="width:100%;font-size: 100%;display:contents;" [ngClass]="nodeClass(dataItem.FamilyId)"> 
                                {{flatDropDownDisplay(dataItem.FamilyId)}}
                            </div>
                        </ng-template>
                        <ng-template kendoDropDownListItemTemplate let-dataItem>
                            <div style="width:100%;" [ngClass]="selectedableDropDownNodeClass(dataItem.FamilyId,mainSupplierFamily?.FamilyId == dataItem.FamilyId)" [innerHTML]="flatDropDownDisplay(dataItem.FamilyId)">
                            </div>
                        </ng-template>
                    </kendo-dropdownlist>
                    <validation-errors [form]="ngFrmsupplierknowledge" controlName="mainFamilyCodTree"></validation-errors>
                    <PRE *ngIf="sharedDatasSvc.debug">
                        {{mainSupplierFamily | json}}
                    </PRE>
                </div>
            </div>


            <div class="card" *ngIf="firstLevelQuestions.length>0">
                <div class="card-header">
                    <label class="control-label" paflabel="Specificites"></label>
                </div>
                <div class="card-body">                    
                    <question-row *ngFor="let question of firstLevelQuestions" [question]="question" [visibleQuestions]="visibleQuestions" [answers]="supplier.SupplierAnswers" [readonly]="specificitesDisabled || !isEditing()"></question-row>
                </div>
            </div>

            <div *ngIf="showAccidentologie" class="mt-2">
                <accidentologie #accComponent name="accComponent" [supplier]="supplier"  [readonly]="accidentologieDisabled || !isEditing()"></accidentologie>
            </div>
        </div>
    </div>
</form>